import { OAuthProviderSchema } from "./oauth-providers";
import { z } from "zod";
export const ExternalOAuthRequest = z.object({
    id: z.string(),
    provider: OAuthProviderSchema,
    userId: z.string(),
    state: z.string(),
    createdAt: z.coerce.date(),
});
